import * as React from 'react';

import { NoServices } from 'components/NoServices/NoServices';

import { useServicesPage } from 'hooks/page/services/useServicesPage';

import { PlayfulService } from './PlayfulService';

import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const Services = () => {
  const { services, renderService, renderServiceOptionsModal } =
    useServicesPage();

  if (services.length === 0) {
    return <NoServices />;
  }

  return (
    <React.Fragment>
      <div className={s1.content}>
        {services.map((service) => (
          <React.Fragment key={service.guid}>
            {renderService(service, PlayfulService)}
          </React.Fragment>
        ))}
      </div>
      {renderServiceOptionsModal()}
    </React.Fragment>
  );
};
